import React, { FC, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'
import type { PaginationOptionsInterface } from './Hooks/paginationHookTypes.d'
import { Button } from '@corratech/pylot-ui'
import { Dropdown } from '@corratech/pylot-dropdown'
import { ChevronDown, ChevronUp } from 'react-feather'
import cn from 'classnames'
import s from './PaginationToolbarStyle.module.scss'

type Props = {
    setPageSize: Dispatch<SetStateAction<number>>
    pageSize: number
    setPage: Dispatch<SetStateAction<number>>
    options: Array<PaginationOptionsInterface>
}

export const DropDownLimit: FC<Props> = ({
    setPageSize,
    pageSize,
    setPage,
    options
}) => {
    const { t } = useTranslation()

    const handlePageSize = (value: number) => {
        setPageSize(value)
        setPage(1)
        return null
    }

    const OpenDropdownArrow = () => {
        return (
            <div className={s['dropdown-label']}>
                <Button type="button" variant="link">
                    {pageSize}
                </Button>
                <ChevronUp width="20" height="20" />
            </div>
        )
    }

    const CloseDropdownArrow = () => {
        return (
            <div className={s['dropdown-label']}>
                <Button type="button" variant="link">
                    {pageSize}
                </Button>
                <span>
                    <ChevronDown width="20" height="20" />
                </span>
            </div>
        )
    }

    return (
        <div className={cn(s['pagination-dropdown'], 'pagination-dropdown')}>
            <span>{t('Show ')}</span>
            <Dropdown
                openedDisplay={<OpenDropdownArrow />}
                closedDisplay={<CloseDropdownArrow />}
            >
                <ul className={s['pagination-dropdown-list']}>
                    {options?.map((items, key) => (
                        <li key={key} value={items.optionValue}>
                            <Button
                                onClick={() => {
                                    handlePageSize(items.optionValue)
                                }}
                                onKeyUp={() => {
                                    handlePageSize(items.optionValue)
                                }}
                                variant="link"
                            >
                                {items.optionLabel}
                            </Button>
                        </li>
                    ))}
                </ul>
            </Dropdown>
            <span>{t('per page')}</span>
        </div>
    )
}
